export { FEATURE_FLAGS } from '@lib/analytics/amplitude/plugins/features/featureFlags'
export type { FeatureFlagKey } from '@lib/analytics/amplitude/plugins/features/featureFlags'
export { useFeatureFlag } from '@lib/analytics/amplitude/plugins/features/hooks/useFeatureFlag'
import { init } from '@lib/analytics/amplitude/plugins/features/core'

export default {
  init,
}
